import "../k";

function addLabel(isReal, comps?) {
  const labelSprite = isReal ? "real" : "fake";
  const labelText = isReal ? "not AI-generated" : "AI-generated";

  const parent = add([anchor("center"), ...comps]);
  const label = parent.add([
    anchor("center"),
    sprite(labelSprite),
    scale(1),
    pos(0, -180),
    animate(),
    z(3)
  ]);

  label.add([
    text("THIS IS", { font: "rumeur", size: 20 }),
    anchor("center"),
    color(Color.BLACK),
    pos(0, 32),
    z(3)
  ]);
  label.add([
    text(labelText, { font: "rumeur", size: 26 }),
    anchor("center"),
    color(Color.BLACK),
    pos(0, 57),
    z(3)
  ]);
  label.animate("scale", [vec2(0, 0), vec2(1, 1)], {
    duration: 1,
    loops: 1,
    easing: easings.easeOutElastic,
  });
  return label;
}

export { addLabel };
